/* Hamada Supplements Theme — Pro JS */
(function () {
  'use strict';

  /* ---- Sticky header shadow ---- */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---- Mobile nav ---- */
  const toggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open);
      nav.style.cssText = open
        ? 'display:flex;flex-direction:column;position:fixed;top:72px;left:0;right:0;background:rgba(13,13,13,0.98);padding:24px;gap:8px;border-bottom:1px solid rgba(255,215,0,0.2);backdrop-filter:blur(20px);z-index:998'
        : '';
    });
    document.addEventListener('click', e => {
      if (!header.contains(e.target)) { nav.classList.remove('nav-open'); nav.style.cssText = ''; }
    });
  }

  /* ---- Quantity buttons ---- */
  document.querySelectorAll('.qty-wrap').forEach(wrap => {
    const minus = wrap.querySelector('.qty-minus');
    const plus  = wrap.querySelector('.qty-plus');
    const input = wrap.querySelector('.qty-input');
    if (minus) minus.addEventListener('click', () => { if (+input.value > 1) input.value = +input.value - 1; input.dispatchEvent(new Event('change')); });
    if (plus)  plus.addEventListener('click',  () => { input.value = +input.value + 1; input.dispatchEvent(new Event('change')); });
  });

  /* ---- Product gallery thumbnails ---- */
  document.querySelectorAll('.thumb-btn').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mainImg = document.getElementById('main-img');
      if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
      document.querySelectorAll('.thumb-btn').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* ---- Option/variant selection ---- */
  document.querySelectorAll('.option-btns').forEach(group => {
    group.querySelectorAll('.option-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('.option-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
      });
    });
  });

  /* ---- Marquee duplicate for seamless loop ---- */
  const track = document.querySelector('.marquee-track');
  if (track) { track.innerHTML += track.innerHTML; }

  /* ---- Smooth reveal on scroll ---- */
  if ('IntersectionObserver' in window) {
    const style = document.createElement('style');
    style.textContent = '.reveal{opacity:0;transform:translateY(28px);transition:opacity 0.6s ease,transform 0.6s ease}.reveal.visible{opacity:1;transform:none}';
    document.head.appendChild(style);
    document.querySelectorAll('.product-card,.why-item,.testimonial-card,.cat-card,.section-header').forEach(el => {
      el.classList.add('reveal');
    });
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  }

})();



/* ── Language Toggle — FIXED ────────────────────────────────── */
(function () {
  var STORAGE_KEY = 'hs_lang';
  var html = document.documentElement;
  var toggleBtn = document.getElementById('lang-toggle');
  var langLabel = document.getElementById('lang-label');

  function applyLanguage(lang, save) {
    var isAr = (lang === 'ar');

    // Set HTML attributes
    html.setAttribute('lang', lang);
    html.setAttribute('dir', isAr ? 'rtl' : 'ltr');

    // Button shows the OTHER language (what you switch TO)
    if (langLabel) langLabel.textContent = isAr ? 'EN' : 'AR';

    // Save preference
    if (save !== false) localStorage.setItem(STORAGE_KEY, lang);

    // Handle data-ar / data-en simple text elements (skip select options — handled below)
    document.querySelectorAll('[data-ar][data-en]:not(option)').forEach(function (el) {
      el.textContent = isAr
        ? el.getAttribute('data-ar')
        : el.getAttribute('data-en');
    });

    // Update <select> <option> text (spans inside options don't work)
    document.querySelectorAll('option[data-ar][data-en]').forEach(function (el) {
      el.textContent = isAr
        ? el.getAttribute('data-ar')
        : el.getAttribute('data-en');
    });
  }

  // Read saved preference — default is 'ar'
  var saved = localStorage.getItem(STORAGE_KEY);
  if (!saved || (saved !== 'ar' && saved !== 'en')) saved = 'ar';
  applyLanguage(saved, false);

  // Toggle on click
  if (toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      var current = html.getAttribute('lang') || 'ar';
      applyLanguage(current === 'ar' ? 'en' : 'ar');
    });
  }
})();

/* ── Search Drawer Toggle ──────────────────────────────────── */
(function () {
  var toggleBtn = document.getElementById('search-toggle');
  var drawer    = document.getElementById('search-drawer');
  var closeBtn  = document.getElementById('search-close');
  var input     = document.getElementById('search-input');

  if (!toggleBtn || !drawer) return;

  function openSearch() {
    drawer.classList.add('open');
    toggleBtn.classList.add('active');
    if (input) setTimeout(function () { input.focus(); }, 50);
  }

  function closeSearch() {
    drawer.classList.remove('open');
    toggleBtn.classList.remove('active');
  }

  toggleBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    drawer.classList.contains('open') ? closeSearch() : openSearch();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  document.addEventListener('click', function (e) {
    if (!drawer.contains(e.target) && !toggleBtn.contains(e.target)) {
      closeSearch();
    }
  });
})();
